export const visit = (vm, at) => {
at({ "pt-br": { "hc-0133": { "sample-data-banner": { "title": "Modo de dados de amostra", "description": "Voc\xEA pode explorar e editar esses dados at\xE9 estar pronto para fazer upload dos seus pr\xF3prios dados" } } } });
};